const Download: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="21"
      height="21"
      viewBox="0 0 21 21"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="icon_outlined_application_download_clip_mask_"
            data-name="icon/outlined/application/download (clip mask)"
            width="21"
            height="21"
            transform="translate(0 0.367)"
            fill="var(--gray-1)"
          />
        </clipPath>
      </defs>
      <g id="icon-outlined-application-download" transform="translate(0 -0.367)">
        <rect
          id="icon_outlined_application_download_clip_mask_2"
          data-name="icon/outlined/application/download (clip mask)"
          width="21"
          height="21"
          transform="translate(0 0.367)"
          fill="none"
        />
        <g
          id="icon_outlined_application_download"
          data-name="icon/outlined/application/download"
          clipPath="url(#clip-path)"
        >
          <g
            id="icon_outlined_application_download_clip_group_"
            data-name="icon/outlined/application/download (clip group)"
          >
            <rect
              id="icon_outlined_application_download_style_"
              data-name="icon/outlined/application/download (style)"
              width="21"
              height="21"
              transform="translate(0 0.367)"
              fill="none"
            />
            <path
              id="Vector"
              d="M14.941,14.69H.667A.668.668,0,0,1,0,14.022V9.891a.167.167,0,0,1,.167-.167H1.419a.167.167,0,0,1,.167.167V13.1H14.022V9.891a.167.167,0,0,1,.167-.167h1.252a.167.167,0,0,1,.167.167v4.131A.668.668,0,0,1,14.941,14.69ZM7.8,10.518a.168.168,0,0,1-.074-.017.165.165,0,0,1-.058-.047L5.336,7.5a.166.166,0,0,1,.131-.269H7.009V.167A.167.167,0,0,1,7.176,0H8.428A.167.167,0,0,1,8.6.167V7.228h1.546a.166.166,0,0,1,.131.269L7.936,10.454a.174.174,0,0,1-.058.047A.167.167,0,0,1,7.8,10.518Z"
              transform="translate(2.88 3.339)"
              fill="var(--black-1)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Download;
